import React, {useState, useEffect} from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";

import routes from "./routes";
import withTracker from "./withTracker";
import {
  CircularProgress
} from "@mui/material";
import "bootstrap/dist/css/bootstrap.min.css";
import "./shards-dashboard/styles/shards-dashboards.1.1.0.min.css";
import {Redirect, Switch } from "react-router-dom";
import Login from "./views/Login";
import SignIn from "./views/SignIn";

import { auth } from "./firebase"
const ProtectedRoute = ({ component: Component, ...rest }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null); // null = loading state
  
  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  }

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      if (user) {
        try {
          const token = await user.getIdToken(true); // true forces token refresh
          console.log("User Token:", token);


          // localStorage.setItem("userToken", token); // Store token if needed
          // localStorage.setItem("userRole", role); // Store token if needed
        } catch (error) {
          console.error("Error getting token:", error);
        }
      }
    });
    return () => unsubscribe(); // Cleanup listener on unmount
  }, []);

  useEffect(() => {
    const storedAuth = localStorage.getItem("isAuthenticated") === "true";
    const token = getCookie('customToken');

    if (storedAuth) {
      setIsAuthenticated(true);
    } else if (token) {
      // Try signing in with the token
      auth.signInWithCustomToken(token)
      .then(async (userCredential) => {
        const user = userCredential.user;
        
        if (user) {
          const authToken = await user.getIdToken(true); // Force token refresh
          const idTokenResult = await user.getIdTokenResult();
          let role = "user";
          if (idTokenResult.claims["superAdmin"]) {
            role = "superAdmin";
          } else if (idTokenResult.claims["Admin"]) {
            role = "Admin";
          } else if (idTokenResult.claims["Expert"]) {
            role = "Expert";
          }
          const userRole = role|| "user"; // Default role if not set
          const userName = user.displayName || "user"; // Default name if not set
    
          // Save data to localStorage
          localStorage.setItem("isAuthenticated", "true");
          localStorage.setItem("userToken", authToken);
          localStorage.setItem("userRole", userRole);
          localStorage.setItem("name", userName);
    
          setIsAuthenticated(true);
        }
      })
      .catch(() => setIsAuthenticated(false));
    
    } else {
      setIsAuthenticated(false);
    }
  }, []);

  if (isAuthenticated === null) {
    return <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
    <CircularProgress size={50} />
  </div>; // Show a loading indicator while checking auth
  }


  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated ? <Component {...props} /> : <Redirect to="/login" />
      }
    />
  );
};


export default () => {
  const [role, setRole] = useState(localStorage.getItem("userRole")); // Track role in state

  useEffect(() => {
    const handleStorageChange = () => {
      setRole(localStorage.getItem("userRole")); // Update role when it changes
    };

    window.addEventListener("storage", handleStorageChange); // Listen to changes
    return () => window.removeEventListener("storage", handleStorageChange); // Cleanup
  }, []);

  const filteredRoutes = routes.filter(route => route.roles.includes(role)); // Filter routes based on the latest role


  return (
    <Router basename={process.env.REACT_APP_BASENAME || ""}>
      <Switch>
        <Route path="/login" component={SignIn} /> {/* Always allow Login Page */}
        <Route
          exact
          path="/"
          render={() => {
            const userRole = localStorage.getItem("userRole");
            // Define role-based redirects
            const roleRedirects = {
              user: "/home",
              Admin: "/home",
              superAdmin: "/home",
              Expert: "/feedback/summary",
            };

            // Redirect based on user role
            return <Redirect to={roleRedirects[userRole] || "/login"} />;
          }}
        />
        {filteredRoutes.map((route, index) => (
          <ProtectedRoute
            key={index}
            path={route.path}
            exact={route.exact}
            component={withTracker((props) => (
              <route.layout {...props}>
                <route.component {...props} />
              </route.layout>
            ))}
          />
        ))}
                <Route
          exact
          path="*"
          render={() => {
            const userRole = localStorage.getItem("userRole");
            const isAuthenticated = localStorage.getItem("isAuthenticated") === "true";
            // Define role-based redirects
            const roleRedirects = {
              user: "/home",
              Admin: "/home",
              superAdmin: "/home",
              Expert: "/feedback/summary",
            };

            // Redirect based on user role
            return <Redirect to={isAuthenticated ? roleRedirects[userRole] : "/login"} />;
          }}
        />
      </Switch>
    </Router>
  );
};


//test check
